<template>
  <div>
    <b-form>
      <!-- Viikonpäivät -->
      <b-form-group
        :label="$t('announcement_schedule.weekdays_hint')"
        :label-for="generateID(1)"
      >
        <!-- prop `add-on-change` is needed to enable adding tags vie the `change` event -->
        <b-form-tags
          v-model="form.weekdays"
          size="lg"
          add-on-change
          no-outer-focus
          class="mb-2"
        >
          <template
            v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }"
          >
            <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag
                  @remove="removeTag(tag)"
                  :title="tag"
                  :disabled="disabled"
                  variant="secondary"
                  >{{ $t('weekdays.' + tag.toLowerCase()) }}</b-form-tag
                >
              </li>
            </ul>
            <b-form-select
              v-bind="inputAttrs"
              v-on="inputHandlers"
              :disabled="disabled || availableOptions.length === 0"
              :options="availableOptions"
            >
              <template v-slot:first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value="">
                  {{ $t('announcement_schedule.weekdays_hint') }}
                </option>
              </template>
            </b-form-select>
          </template>
        </b-form-tags>
      </b-form-group>

      <b-form-group
        :label="$t('announcement_schedule.valid_begin_date')"
        :label-for="generateID(2)"
      >
        <b-form-datepicker
          :id="generateID(2)"
          v-model="form.validityBegins"
          class="mb-2"
          :disabled="disabled"
          :placeholder="this.$t('datepicker.labelNoDateSelected')"
          :locale="this.$t('datepicker.locale')"
        ></b-form-datepicker>
      </b-form-group>

      <b-form-group
        :label="$t('announcement_schedule.valid_end_date')"
        :label-for="generateID(3)"
      >
  
        <b-form-datepicker
          :id="generateID(3)"
          v-model="displayValidityEnds"
          :min="this.form.validityBegins"
          :max="max"
          class="mb-2"
          :disabled="disabled"
          :placeholder="$t('announcement_schedule.valid_until_further_notice')"
          :locale="this.$t('datepicker.locale')"
        ></b-form-datepicker>
     
        <b-button 
          v-if="form.validityEnds && !isValidUntilFurtherNotice"
          variant="outline-secondary" 
          size="sm" 
          @click="setValidUntilFurtherNotice"
          class="mt-1"
        >
          {{ $t('announcement_schedule.set_valid_until_further_notice') }}
        </b-button>
  
      </b-form-group>

      <b-row>
        <b-col>
          <TimeInput
            :label="$t('announcement_schedule.show_begin')"
            v-model="form.showingBegins"
          ></TimeInput>
        </b-col>
        <b-col>
          <TimeInput
            :label="$t('announcement_schedule.show_ends')"
            v-model="form.showingEnds"
          ></TimeInput>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import moment from 'moment'
import TimeInput from '@/components/Generic/TimeInput'

export default {
  name: 'AnnouncementScheduleEntry',
  props: ['args'],
  components: {
    TimeInput,
  },
  data() {

    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth() + 120)

    return {
      passedFormData: this.args,
      min: minDate,
      max: maxDate,
      weekdays: [
        'MONDAY',
        'TUESDAY',
        'WEDNESDAY',
        'THURSDAY',
        'FRIDAY',
        'SATURDAY',
        'SUNDAY',
      ],
      form: {
        showingBegins: '00:00',
        showingEnds: '23:59',
        weekdays: [
          'MONDAY',
          'TUESDAY',
          'WEDNESDAY',
          'THURSDAY',
          'FRIDAY',
          'SATURDAY',
          'SUNDAY',
        ],
        validityBegins: minDate,
      },
      disabled: false,
      baseId: null,
    }
  },
  beforeCreate: function () {},
  created: function () {
    if (this.passedFormData != null && this.passedFormData.showingBegins) {
      this.form = Object.assign({}, this.passedFormData)

      // formatointi ignoroi tässä vaiheessa aikavyöhykearvon
      var beg = moment(this.passedFormData.showingBegins, 'HH:mm[.....]')
      this.form.showingBegins = beg.format('HH:mm')

      var end = moment(this.passedFormData.showingEnds, 'HH:mm[.....]')
      this.form.showingEnds = end.format('HH:mm')

      var vb = moment(this.passedFormData.validityBegins, 'YYYY-MM-DD')
      this.form.validityBegins = vb.format('YYYY-MM-DD')

      if (this.passedFormData.validityEnds) {
        var ve = moment(this.passedFormData.validityEnds, 'YYYY-MM-DD')
        var endDate = ve.format('YYYY-MM-DD')
        this.form.validityEnds = endDate === '2099-12-31' ? null : endDate
      }
    }
  },
  computed: {
    availableOptions() {
      var availableWeekdays = this.weekdays.filter(
        (opt) => this.form.weekdays.indexOf(opt) === -1
      )
      var ret = []
      var vm = this
      availableWeekdays.forEach(function (wd) {
        var item = { value: wd, text: vm.$t('weekdays.' + wd.toLowerCase()) }
        ret.push(item)
      })
      return ret
    },
    isValidUntilFurtherNotice() {
      return !this.form.validityEnds || this.form.validityEnds === '2099-12-31'
    },
    displayValidityEnds: {
      get() {
        if (this.isValidUntilFurtherNotice) {
          return null
        }
        return this.form.validityEnds
      },
      set(value) {
        this.form.validityEnds = value
      }
    }
  },
  mounted() {
    this.baseId = Math.floor(Math.random() * Math.floor(666))
  },
  watch: {},
  methods: {
    newEntry: function () {
      //console.log("uusi entry");
      //this.form = JSON.parse(JSON.stringify(this.defaultFormData));
    },
    resetEntry: function () {
      //console.log("resetoi entry");
      //this.form = JSON.parse(JSON.stringify(this.defaultFormData));
    },
    setEntryData: function () {
      //console.log(newData);
    },
    generateID: function (compId) {
      return 'comp-' + this.baseId + '-' + compId
    },
    setValidUntilFurtherNotice() {
      this.form.validityEnds = null
    },
    getEntry: function () {
      const entry = { ...this.form }
      if (!entry.validityEnds || entry.validityEnds === null) {
        entry.validityEnds = '2099-12-31'
      }
      return entry
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//$input-disabled-bg: #fff;
//$btn-font-family: 'Monserrat';
//@import 'node_modules/bootstrap-vue/src/components/calendar/index.scss';
//@import 'node_modules/bootstrap/scss/_buttons.scss';
</style>
